export const frontmatter = {
    "draft": true,
    "title": "Permisos",
    "description": "Sistema de permisos en OnnIA.",
    "sidebar_label": "Permisos",
    "sidebar_group": "referencia",
    "sidebar_order": 3
}

export const toc = []